import { render, staticRenderFns } from "./IntegrationsType.vue?vue&type=template&id=399e2093"
import script from "./IntegrationsType.vue?vue&type=script&lang=js"
export * from "./IntegrationsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports